export const GET_USEVIOCE = 'GET_USEVIOCE'; // 获取用户是否使用语音播报功能
export const MODIFY_USEVIOCE = 'MODIFY_USEVIOCE'; // 修改是否使用语音播报功能

export const GET_WXBIND = 'GET_WXBIND'; // 获取用户是否绑定微信功能
export const MODIFY_WXBIND = 'MODIFY_WXBIND'; // 修改是否绑定微信功能

export const GET_USETIP = 'GET_USETIP'; // 获取用户是否要在下单页面展示选择加注模式
export const MODIFY_USETIP = 'MODIFY_USETIP'; // 修改用户是否要在下单页面展示选择加注模式

export default {
    state: {
        useVoice: localStorage.hasOwnProperty('useVoice')?JSON.parse(localStorage.getItem('useVoice')):true,
        wxBind: localStorage.hasOwnProperty('wxBind')?JSON.parse(localStorage.getItem('wxBind')):true,
        usedTip: localStorage.hasOwnProperty('usedTip')?JSON.parse(localStorage.getItem('usedTip')):true,
    },
    getters: {
        [GET_USEVIOCE] (state) {
            if (typeof state.useVoice === 'string'){
                state.useVoice = JSON.parse(state.useVoice);
            }
            return state.useVoice;
        },
        [GET_WXBIND] (state) {
            if (typeof state.wxBind === 'string'){
                state.wxBind = JSON.parse(state.wxBind);
            }
            return state.wxBind;
        },
        [GET_USETIP] (state) {
            if (typeof state.usedTip === 'string'){
                state.usedTip = JSON.parse(state.usedTip);
            }
            return state.usedTip;
        },
    },
    mutations: {
        [MODIFY_USEVIOCE] (state, item) {
            localStorage.setItem('useVoice', JSON.stringify(item))
            state.useVoice = item;
        },
        [MODIFY_WXBIND] (state, item) {
            localStorage.setItem('wxBind', JSON.stringify(item))
            state.wxBind = item;
        },
        [MODIFY_USETIP] (state, item) {
            localStorage.setItem('usedTip', JSON.stringify(item))
            state.usedTip = item;
        },
    },
    actions: {
        [MODIFY_USEVIOCE] ({commit}, item) {
            commit(MODIFY_USEVIOCE, item);
        },
        [MODIFY_WXBIND] ({commit}, item) {
            commit(MODIFY_WXBIND, item);
        },
        [MODIFY_USETIP] ({commit}, item) {
            commit(MODIFY_USETIP, item);
        },
    }
};
